import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarker2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMarker2"><Path d="M20.5 12.5L17.5 9.5L13.5 8.5L7.5 14.5L8.5 18.5L11.5 21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8 14L5 11L6.5 2.5L13 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMarker2;
